import React, { Suspense } from "react";
import Loading from "../../components/Loading";
import "../sample/Simpal.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import { loadUser } from "../../actions/authActions";

import {
  Col,
  Container,
  Row,
  Card,
  CardText,
  CardSubtitle,
  CardTitle,
  CardBody,
  Button,
} from "reactstrap";
import SampleNewTable from "./SampleNewTable";
import Header from "../../DefaultLayout/Header";
import { connect } from "react-redux";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";
function SimpaleTable(props) {
  const isAuth = props.auth.isAuthenticated;
  const {frontLabelsName} = props.label;
  const userName = props.auth.user;
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}

        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container mt-5 mb-4">
        <Card className="design-left">
          <img src="assets/01.png" alt="img-right" className="set-ledt-img" />
          <CardBody>
            <h2 className="font-setting">
            {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_sample_assets_file")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_sample_assets_file"
                            )[0]["value"] || "lbl_sample_assets_file"
                          : "lbl_sample_assets_file"
                        : "lbl_sample_assets_file"}
            </h2>
            <hr></hr>
            <div className="desc-table">
              <p>
            
                {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_sample_assets_file_details")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_sample_assets_file_details"
                            )[0]["value"] || "lbl_sample_assets_file_details"
                          : "lbl_sample_assets_file_details"
                        : "lbl_sample_assets_file_details"} 
              </p>
            </div>

            <div className="table-main">
              <SampleNewTable />
            </div>
          </CardBody>
        </Card>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  loadUser,
})(SimpaleTable);
